module.exports = __webpack_public_path__ + "static/media/inviteBg2.afd9a410.png";